export default {
  TOGGLE_ACCOUNT_DRAWER: "account/TOGGLE_ACCOUNT_DRAWER",
  TOGGLE_MINI_CASHIER_DRAWER: "account/TOGGLE_MINI_CASHIER_DRAWER",
  TOOGLE_ACCOUNT_REWARDS_DRAWER: "account/TOOGLE_ACCOUNT_REWARDS_DRAWER"
};
